import { init, capturePageview } from "./src/utils/posthog"

export const onClientEntry = () => {
  init()
}

export const onRouteUpdate = ({ location }) => {
  capturePageview(location.pathname + location.search)
}
